const SubGroupAccountActionTypes = {
	/** ***************** ADD SUB GROUP ACCOUNT DETAILS START *********************** */
	ADD_SUB_GROUP_ACCOUNT_DETAILS_START: 'add_sub_group_account_details_start',
	ADD_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS: 'add_sub_group_account_details_success',
	ADD_SUB_GROUP_ACCOUNT_DETAILS_FAILURE: 'add_sub_group_account_details_failure',
	ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET: 'add_sub_group_account_details_response_reset',
	ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'add_sub_group_account_details_response_changed',
	/** ***************** ADD SUB GROUP ACCOUNT DETAILS END *********************** */

	/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS START *********************** */
	UPDATE_SUB_GROUP_ACCOUNT_DETAILS_START: 'update_sub_group_account_details_start',
	UPDATE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS: 'update_sub_group_account_details_success',
	UPDATE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE: 'update_sub_group_account_details_failure',
	UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET:
		'update_sub_group_account_details_response_reset',
	UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'update_sub_group_account_details_response_changed',
	/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS END *********************** */

	/** ***************** GET SUB GROUP ACCOUNT LIST START *********************** */
	GET_SUB_GROUP_ACCOUNT_LIST_START: 'get_sub_group_account_list_start',
	GET_SUB_GROUP_ACCOUNT_LIST_SUCCESS: 'get_sub_group_account_list_success',
	GET_SUB_GROUP_ACCOUNT_LIST_FAILURE: 'get_sub_group_account_list_failure',
	GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_RESET: 'get_sub_group_account_list_response_reset',
	GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED: 'get_sub_group_account_list_response_changed',
	/** ***************** GET SUB GROUP ACCOUNT LIST END *********************** */

	/** ***************** FETCH SUB GROUP ACCOUNT DETAILS START *********************** */
	FETCH_SUB_GROUP_ACCOUNT_DETAILS_START: 'fetch_sub_group_account_details_start',
	FETCH_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS: 'fetch_sub_group_account_details_success',
	FETCH_SUB_GROUP_ACCOUNT_DETAILS_FAILURE: 'fetch_sub_group_account_details_failure',
	FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET:
		'fetch_sub_group_account_details_response_reset',
	FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'fetch_sub_group_account_details_response_changed',
	/** ***************** FETCH SUB GROUP ACCOUNT DETAILS END *********************** */

	/** ***************** DELETE SUB GROUP ACCOUNT DETAILS START *********************** */
	DELETE_SUB_GROUP_ACCOUNT_DETAILS_START: 'delete_sub_group_account_details_start',
	DELETE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS: 'delete_sub_group_account_details_success',
	DELETE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE: 'delete_sub_group_account_details_failure',
	DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET:
		'delete_sub_group_account_details_response_reset',
	DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'delete_sub_group_account_details_response_changed',
	/** ***************** DELETE SUB GROUP ACCOUNT DETAILS END *********************** */
};

export default SubGroupAccountActionTypes;
